import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_version',
	prefix: 'game_version',
	key: 'game_version_id',
	fields: {
		game_version_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		game_version_name: Model.SCHEMA_TEXT,
		game_version_localised: Model.SCHEMA_TEXT,
		game_version_sort: Model.SCHEMA_TEXT,
		game_version_avatar: Model.SCHEMA_TEXT,
		game_version_year: Model.SCHEMA_NUMBER,
		game_version_date_avatar: Model.SCHEMA_NUMBER,
		game_version_storage_width: Model.SCHEMA_NUMBER,
		game_version_storage_length: Model.SCHEMA_NUMBER,
		game_version_storage_depth: Model.SCHEMA_NUMBER,
		game_version_storage_weight: Model.SCHEMA_NUMBER,
		game_version_worth_value: Model.SCHEMA_NUMBER,
		game_version_worth_date: Model.SCHEMA_NUMBER,
		game_version_worth_count: Model.SCHEMA_NUMBER,
		game_version_worth_type: Model.SCHEMA_NUMBER
	},
	methods: {
		to_array: function() {
			return {
				id: this.get_id(),
				name: this.get_name(),
				localised: this.get_localised(),
				year: this.get_year() || 0
			}
		}
	}
})
